import React from "react";
import QRCode from "react-qr-code";

const Qr = () => {
  const qrValue = "CC_HREXORA_GAME"; // text you want after scanning

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f3f4f6",
      }}
    >
      <div
        style={{
          padding: "24px",
          borderRadius: "16px",
          background: "#ffffff",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          textAlign: "center",
        }}
      >
        <h2 style={{ marginBottom: "16px" }}>Scan this QR</h2>

        <QRCode
          value={qrValue}
          size={200}
          style={{ height: "auto", maxWidth: "100%", width: "100%" }}
        />

        <p style={{ marginTop: "16px", fontSize: "14px", color: "#4b5563" }}>
          Data in QR: <strong>{qrValue}</strong>
        </p>
      </div>
    </div>
  );
};

export default Qr;
